
import { useState } from 'react';

export default function Support() {
  const [activeTab, setActiveTab] = useState('support');
  const [showModal, setShowModal] = useState<string | null>(null);

  const openModal = (content: string) => {
    setShowModal(content);
  };

  const closeModal = () => {
    setShowModal(null);
  };

  // 支援申し込みフォームハンドラ
  const handleSupportApplication = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    try {
      const response = await fetch('https://readdy.ai/api/form/d39g7nafkoblkdk5cqm0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        alert('ご支援のお申し出をありがとうございます！担当者よりご連絡いたします。');
        (e.target as HTMLFormElement).reset();
        closeModal();
      } else {
        alert('送信に失敗しました。もう一度お試しください。');
      }
    } catch (error) {
      alert('送信に失敗しました。もう一度お試しください。');
    }
  };

  // お問い合わせフォームハンドラ
  const handleContactInquiry = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    try {
      const response = await fetch('https://readdy.ai/api/form/d39g7nafkoblkdk5cqng', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        alert('お問い合わせありがとうございます！返信をお待ちください。');
        (e.target as HTMLFormElement).reset();
        closeModal();
      } else {
        alert('送信に失敗しました。もう一度お試しください。');
      }
    } catch (error) {
      alert('送信に失敗しました。もう一度お試しください。');
    }
  };

  // ニュースレター購読フォームハンドラ
  const handleNewsletterSubscription = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    try {
      const response = await fetch('https://readdy.ai/api/form/d39g7nafkoblkdk5cqmg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        alert('ニュースレターへの購読ありがとうございます！');
        (e.target as HTMLFormElement).reset();
        closeModal();
      } else {
        alert('送信に失敗しました。もう一度お試しください。');
      }
    } catch (error) {
      alert('送信に失敗しました。もう一度お試しください。');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* ヒーローセクション */}
      <section 
        className="relative py-20 bg-cover bg-center bg-top"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/a3ee856eff1954e668ff056ed1364f9a.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 via-purple-900/70 to-indigo-900/80"></div>
        <div className="relative z-10 max-w-6xl mx-auto px-6 text-center text-white">
          <h1 className="text-6xl font-bold mb-6">
            志を支援する
            <span className="block text-5xl bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent mt-4">
              AI育成学舎への応援
            </span>
          </h1>
          <p className="text-xl text-blue-100 max-w-4xl mx-auto leading-relaxed mb-8">
            誰も置き去りにしない社会を目指すAI育成学舎の活動を、様々な形でご支援いただけます。
            あなたの想いと力を、ぜひお貸しください。
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => openModal('support-application')}
              className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:from-orange-600 hover:to-red-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-3"
            >
              <i className="ri-heart-3-line text-xl"></i>
              支援のお申し込み
            </button>
            
            <button 
              onClick={() => {
                if (typeof window.REACT_APP_NAVIGATE === 'function') {
                  window.REACT_APP_NAVIGATE('/');
                } else {
                  console.error('REACT_APP_NAVIGATE is not defined or not a function');
                }
              }}
              className="bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-white/30 transition-all border border-white/30 whitespace-nowrap inline-flex items-center gap-3"
            >
              <i className="ri-arrow-left-line text-xl"></i>
              ホームに戻る
            </button>
          </div>
        </div>
      </section>

      {/* タブナビゲーション */}
      <section className="py-8 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="bg-white rounded-2xl p-2 shadow-lg">
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => setActiveTab('support')}
                className={`px-6 py-3 rounded-xl font-medium transition-all ${
                  activeTab === 'support'
                    ? 'bg-gradient-to-r from-orange-500 to-red-600 text-white shadow-lg'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <i className="ri-heart-3-line mr-2"></i>
                支援の種類
              </button>
              <button
                onClick={() => setActiveTab('contact')}
                className={`px-6 py-3 rounded-xl font-medium transition-all ${
                  activeTab === 'contact'
                    ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <i className="ri-mail-line mr-2"></i>
                お問い合わせ
              </button>
              <button
                onClick={() => setActiveTab('newsletter')}
                className={`px-6 py-3 rounded-xl font-medium transition-all ${
                  activeTab === 'newsletter'
                    ? 'bg-gradient-to-r from-green-500 to-teal-600 text-white shadow-lg'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <i className="ri-notification-3-line mr-2"></i>
                ニュースレター
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 支援の種類タブ */}
      {activeTab === 'support' && (
        <section className="py-16 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                支援の種類
              </h2>
              <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                AI育成学舎の活動は、多くの方々のご支援によって支えられています。
                あなたのスキルや想いに合わせた支援方法をお選びください。
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
              {/* 資金支援 */}
              <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-3xl p-8 border border-orange-200 hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center mb-6">
                  <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">資金支援</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  講座運営、教材開発、システム維持にかかる費用をご支援いただけます。継続的な活動のために重要な支援です。
                </p>
                <ul className="text-gray-600 text-sm space-y-2 mb-6">
                  <li>• 単発支援：1,000円〜</li>
                  <li>• 継続支援：月額500円〜</li>
                  <li>• 企業スポンサー：要相談</li>
                </ul>
                <button 
                  onClick={() => openModal('support-application')}
                  className="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white py-3 rounded-xl font-bold hover:from-orange-600 hover:to-red-700 transition-all"
                >
                  資金支援を申し込む
                </button>
              </div>

              {/* 技術支援 */}
              <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl p-8 border border-blue-200 hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center mb-6">
                  <i className="ri-code-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">技術支援</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  プログラミング、デザイン、動画編集など、あなたの技術スキルを活かして活動をお手伝いください。
                </p>
                <ul className="text-gray-600 text-sm space-y-2 mb-6">
                  <li>• Webシステム開発</li>
                  <li>• 教材デザイン制作</li>
                  <li>• 動画編集・配信サポート</li>
                </ul>
                <button 
                  onClick={() => openModal('support-application')}
                  className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white py-3 rounded-xl font-bold hover:from-blue-600 hover:to-purple-700 transition-all"
                >
                  技術支援を申し込む
                </button>
              </div>

              {/* 講師支援 */}
              <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-3xl p-8 border border-green-200 hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl flex items-center justify-center mb-6">
                  <i className="ri-presentation-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">講師支援</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  AI、技術、教育の専門知識を活かして、講座の講師やメンターとしてご参加ください。
                </p>
                <ul className="text-gray-600 text-sm space-y-2 mb-6">
                  <li>• オンライン講座の講師</li>
                  <li>• 質問対応・メンタリング</li>
                  <li>• 教材監修・アドバイス</li>
                </ul>
                <button 
                  onClick={() => openModal('support-application')}
                  className="w-full bg-gradient-to-r from-green-500 to-teal-600 text-white py-3 rounded-xl font-bold hover:from-green-600 hover:to-teal-700 transition-all"
                >
                  講師支援を申し込む
                </button>
              </div>

              {/* 広報支援 */}
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl p-8 border border-purple-200 hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center mb-6">
                  <i className="ri-megaphone-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">広報支援</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  SNS運営、記事執筆、PR活動など、AI育成学舎の認知拡大にご協力ください。
                </p>
                <ul className="text-gray-600 text-sm space-y-2 mb-6">
                  <li>• SNS投稿・拡散協力</li>
                  <li>• ブログ記事執筆</li>
                  <li>• イベント企画・運営</li>
                </ul>
                <button 
                  onClick={() => openModal('support-application')}
                  className="w-full bg-gradient-to-r from-purple-500 to-pink-600 text-white py-3 rounded-xl font-bold hover:from-purple-600 hover:to-pink-700 transition-all"
                >
                  広報支援を申し込む
                </button>
              </div>

              {/* 地域協力 */}
              <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-3xl p-8 border border-yellow-200 hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-orange-600 rounded-2xl flex items-center justify-center mb-6">
                  <i className="ri-community-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">地域協力</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  地域でのイベント開催、会場提供、地域コミュニティとの連携をサポートしてください。
                </p>
                <ul className="text-gray-600 text-sm space-y-2 mb-6">
                  <li>• 地域イベント企画・開催</li>
                  <li>• 会場提供・設備協力</li>
                  <li>• 地域団体との連携</li>
                </ul>
                <button 
                  onClick={() => openModal('support-application')}
                  className="w-full bg-gradient-to-r from-yellow-500 to-orange-600 text-white py-3 rounded-xl font-bold hover:from-yellow-600 hover:to-orange-700 transition-all"
                >
                  地域協力を申し込む
                </button>
              </div>

              {/* その他の支援 */}
              <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-3xl p-8 border border-gray-200 hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-gray-500 to-blue-600 rounded-2xl flex items-center justify-center mb-6">
                  <i className="ri-lightbulb-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">その他の支援</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  上記以外でも、あなたの特技や資源を活かした支援方法があれば、ぜひご相談ください。
                </p>
                <ul className="text-gray-600 text-sm space-y-2 mb-6">
                  <li>• 翻訳・多言語対応</li>
                  <li>• 法務・会計サポート</li>
                  <li>• アイデア・企画提案</li>
                </ul>
                <button 
                  onClick={() => openModal('support-application')}
                  className="w-full bg-gradient-to-r from-gray-500 to-blue-600 text-white py-3 rounded-xl font-bold hover:from-gray-600 hover:to-blue-700 transition-all"
                >
                  その他支援を相談
                </button>
              </div>
            </div>

            {/* 支援の流れ */}
            <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-3xl p-8 border border-orange-200 mb-16">
              <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">支援の流れ</h3>
              <div className="grid md:grid-cols-4 gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold">1</div>
                  <h4 className="font-semibold text-gray-800 mb-2">お申し込み</h4>
                  <p className="text-gray-600 text-sm">支援したい内容を フォームからお申し込み</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold">2</div>
                  <h4 className="font-semibold text-gray-800 mb-2">ご相談</h4>
                  <p className="text-gray-600 text-sm">担当者より詳細のご相談をさせて いただきます</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold">3</div>
                  <h4 className="font-semibold text-gray-800 mb-2">支援開始</h4>
                  <p className="text-gray-600 text-sm">あなたのペースに合わせて 支援活動を開始</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold">4</div>
                  <h4 className="font-semibold text-gray-800 mb-2">継続協力</h4>
                  <p className="text-gray-600 text-sm">定期的な情報共有で 継続的な協力関係を構築</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* お問い合わせタブ */}
      {activeTab === 'contact' && (
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                お問い合わせ
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                AI育成学舎に関するご質問、ご相談、ご提案など、
                お気軽にお問い合わせください。
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-200">
              <form onSubmit={handleContactInquiry} className="space-y-6" data-readdy-form id="contact-inquiry">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      お名前 <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="山田太郎"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      メールアドレス <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="example@email.com"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      電話番号
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="090-1234-5678"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      お問い合わせ種類 <span className="text-red-500">*</span>
                    </label>
                    <select 
                      name="inquiry_type" 
                      required
                      className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">選択してください</option>
                      <option value="講座について">講座について</option>
                      <option value="支援について">支援について</option>
                      <option value="技術的な質問">技術的な質問</option>
                      <option value="取材・メディア">取材・メディア</option>
                      <option value="協業・提携">協業・提携</option>
                      <option value="その他">その他</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    件名 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="subject"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="お問い合わせの件名をご入力ください"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    お問い合わせ内容 <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="message"
                    rows={6}
                    required
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="お問い合わせの詳細をお聞かせください（500文字以内）"
                  ></textarea>
                  <div className="text-xs text-gray-500 mt-1">500文字以内で入力してください</div>
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="bg-gradient-to-r from-blue-600 to-purple-700 text-white px-12 py-4 rounded-full text-lg font-bold hover:from-blue-700 hover:to-purple-800 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-3"
                  >
                    <i className="ri-send-plane-line text-xl"></i>
                    お問い合わせを送信
                  </button>
                </div>
              </form>
            </div>

            {/* よくある質問 */}
            <div className="mt-16">
              <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">よくある質問</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-blue-50 rounded-2xl p-6">
                  <h4 className="font-semibold text-blue-800 mb-3">Q. 講座の参加費用はかかりますか？</h4>
                  <p className="text-blue-700 text-sm">A. 基本的な講座は完全無料で参加いただけます。専門的な個別指導については別途ご相談となります。</p>
                </div>
                <div className="bg-green-50 rounded-2xl p-6">
                  <h4 className="font-semibold text-green-800 mb-3">Q. 年齢制限はありますか？</h4>
                  <p className="text-green-700 text-sm">A. 年齢制限はございません。子どもから高齢者まで、幅広い世代の方にご参加いただいています。</p>
                </div>
                <div className="bg-purple-50 rounded-2xl p-6">
                  <h4 className="font-semibold text-purple-800 mb-3">Q. AI初心者でも大丈夫ですか？</h4>
                  <p className="text-purple-700 text-sm">A. はい、初心者の方も安心してご参加ください。基礎から丁寧にお教えします。</p>
                </div>
                <div className="bg-orange-50 rounded-2xl p-6">
                  <h4 className="font-semibold text-orange-800 mb-3">Q. 支援はどのような形で受け付けていますか？</h4>
                  <p className="text-orange-700 text-sm">A. 資金、技術、講師、広報など、様々な形での支援を受け付けております。詳しくは支援ページをご覧ください。</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ニュースレタータブ */}
      {activeTab === 'newsletter' && (
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                ニュースレター購読
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                AI育成学舎の最新情報、講座案内、AI技術のトレンドなどを
                定期的にお届けいたします。
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-3xl p-8 border border-green-200">
              <div className="text-center mb-8">
                <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-notification-3-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">週刊AI育成通信</h3>
                <p className="text-gray-600">毎週金曜日にお届けする情報メールマガジン</p>
              </div>

              <form onSubmit={handleNewsletterSubscription} className="space-y-6" data-readdy-form id="newsletter-subscription">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      お名前 <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      placeholder="山田太郎"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      メールアドレス <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      placeholder="example@email.com"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      年齢
                    </label>
                    <select name="age" className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500">
                      <option value="">選択してください</option>
                      <option value="10代">10代</option>
                      <option value="20代">20代</option>
                      <option value="30代">30代</option>
                      <option value="40代">40代</option>
                      <option value="50代">50代</option>
                      <option value="60代">60代</option>
                      <option value="70代以上">70代以上</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      関心のある分野
                    </label>
                    <select name="interest" className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500">
                      <option value="">選択してください</option>
                      <option value="AI技術全般">AI技術全般</option>
                      <option value="教育・学習">教育・学習</option>
                      <option value="ビジネス活用">ビジネス活用</option>
                      <option value="社会問題">社会問題</option>
                      <option value="技術動向">技術動向</option>
                      <option value="その他">その他</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    配信頻度の希望
                  </label>
                  <div className="space-y-2">
                    <label className="flex items-center">
                      <input type="radio" name="frequency" value="weekly" className="text-green-600 mr-3" defaultChecked />
                      <span className="text-gray-700">週1回（標準）</span>
                    </label>
                    <label className="flex items-center">
                      <input type="radio" name="frequency" value="biweekly" className="text-green-600 mr-3" />
                      <span className="text-gray-700">隔週1回</span>
                    </label>
                    <label className="flex items-center">
                      <input type="radio" name="frequency" value="monthly" className="text-green-600 mr-3" />
                      <span className="text-gray-700">月1回</span>
                    </label>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ニュースレターに期待すること（任意）
                  </label>
                  <textarea
                    name="expectations"
                    rows={3}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                    placeholder="どのような情報をお届けすれば良いか、ご意見をお聞かせください（500文字以内）"
                  ></textarea>
                  <div className="text-xs text-gray-500 mt-1">500文字以内で入力してください</div>
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="bg-gradient-to-r from-green-600 to-teal-700 text-white px-12 py-4 rounded-full text-lg font-bold hover:from-green-700 hover:to-teal-800 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-3"
                  >
                    <i className="ri-mail-add-line text-xl"></i>
                    ニュースレターに登録
                  </button>
                </div>
              </form>

              {/* ニュースレターの特徴 */}
              <div className="mt-12 grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-time-line text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">定期配信</h4>
                  <p className="text-gray-600 text-sm">毎週金曜日の夕方にお届け。忙しい1週間の終わりに、ほっと一息つける内容です。</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-lightbulb-line text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">実用的な情報</h4>
                  <p className="text-gray-600 text-sm">最新のAI技術から日常で使えるツールまで、実際に役立つ情報を厳選してお届け。</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-shield-check-line text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">プライバシー保護</h4>
                  <p className="text-gray-600 text-sm">メールアドレスは厳重に管理し、第三者に提供することは一切ございません。</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* モーダル */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white p-6 border-b border-gray-200 rounded-t-3xl">
              <div className="flex justify-between items-center">
                <h3 className="text-2xl font-bold text-gray-900">
                  {showModal === 'support-application' && '支援のお申し込み'}
                </h3>
                <button 
                  onClick={closeModal}
                  className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
            </div>
            
            <div className="p-6">
              {showModal === 'support-application' && (
                <form onSubmit={handleSupportApplication} className="space-y-6" data-readdy-form id="support-application">
                  <div className="bg-gradient-to-r from-orange-50 to-red-50 p-6 rounded-2xl mb-6">
                    <h4 className="font-bold text-orange-800 mb-3">支援の種類</h4>
                    <p className="text-orange-700 text-sm">
                      ご希望の支援方法を選択し、詳細をお聞かせください。担当者より具体的なご相談をさせていただきます。
                    </p>
                  </div>

                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        お名前 <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        placeholder="山田太郎"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        メールアドレス <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        placeholder="example@email.com"
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        電話番号
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        placeholder="090-1234-5678"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        所属・職業
                      </label>
                      <input
                        type="text"
                        name="occupation"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        placeholder="株式会社〇〇、フリーランス等"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      支援の種類 <span className="text-red-500">*</span>
                    </label>
                    <select 
                      name="support_type" 
                      required
                      className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    >
                      <option value="">選択してください</option>
                      <option value="資金支援">資金支援</option>
                      <option value="技術支援">技術支援</option>
                      <option value="講師支援">講師支援</option>
                      <option value="広報支援">広報支援</option>
                      <option value="地域協力">地域協力</option>
                      <option value="その他">その他</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      具体的な支援内容・スキル
                    </label>
                    <textarea
                      name="skills"
                      rows={3}
                      maxLength={500}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                      placeholder="お持ちのスキルや、具体的にご協力いただける内容をお聞かせください（500文字以内）"
                    ></textarea>
                    <div className="text-xs text-gray-500 mt-1">500文字以内で入力してください</div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      活動可能な時間帯・頻度
                    </label>
                    <div className="space-y-2">
                      <label className="flex items-center">
                        <input type="checkbox" name="availability" value="平日日中" className="text-orange-600 mr-3" />
                        <span className="text-gray-700">平日日中（9:00-17:00）</span>
                      </label>
                      <label className="flex items-center">
                        <input type="checkbox" name="availability" value="平日夜間" className="text-orange-600 mr-3" />
                        <span className="text-gray-700">平日夜間（18:00-22:00）</span>
                      </label>
                      <label className="flex items-center">
                        <input type="checkbox" name="availability" value="土日祝日" className="text-orange-600 mr-3" />
                        <span className="text-gray-700">土日祝日</span>
                      </label>
                      <label className="flex items-center">
                        <input type="checkbox" name="availability" value="不定期" className="text-orange-600 mr-3" />
                        <span className="text-gray-700">不定期（相談により調整）</span>
                      </label>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      支援への想い・メッセージ
                    </label>
                    <textarea
                      name="message"
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                      placeholder="AI育成学舎への想いや、支援に対するメッセージをお聞かせください（500文字以内）"
                    ></textarea>
                    <div className="text-xs text-gray-500 mt-1">500文字以内で入力してください</div>
                  </div>

                  <div className="flex gap-4">
                    <button
                      type="button"
                      onClick={closeModal}
                      className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap"
                    >
                      キャンセル
                    </button>
                    <button
                      type="submit"
                      className="flex-1 bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 py-3 rounded-lg font-medium hover:from-orange-600 hover:to-red-700 transition-all whitespace-nowrap"
                    >
                      支援を申し込む
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
